var map = {
	"./cds/1.jpg": "af75",
	"./ofresh/1.jpg": "b7dc",
	"./tq/1.jpg": "13a0",
	"./yhnc/1.jpg": "2305",
	"./ys/1.jpg": "8dd8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a7b";